import React from 'react';
import { useParams } from 'react-router-dom';
 import Photos from '../../components/Entity/Cars/ImageModal/CarPhotos';

const CarPhotos = () => { 
  
  const { id } = useParams();

  return  <Photos id={id} ></Photos>   ;
}

export default CarPhotos;